import { render, staticRenderFns } from "./SectionBar.vue?vue&type=template&id=ec22a75c&scoped=true&"
import script from "./SectionBar.vue?vue&type=script&lang=js&"
export * from "./SectionBar.vue?vue&type=script&lang=js&"
import style0 from "./SectionBar.vue?vue&type=style&index=0&id=ec22a75c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec22a75c",
  null
  
)

export default component.exports